import * as React from "react";
import { useState, useEffect } from "react";
import { Admin, Resource, CustomRoutes } from "react-admin";
import { Route } from "react-router-dom";
import { CircularProgress, Box, Typography } from "@mui/material";

import AuthProvider from "./AuthProvider";
import Documents from "./Documents";
import AdminMenu from "./AdminMenu";
import AdminLayout from "./AdminLayout";
import DataProvider from "./DataProvider";
import { NewsList, NewsEdit, NewsCreate } from "./News";
import { AnnouncementsList, AnnouncementsEdit, AnnouncementsCreate } from "./Announcements";
import { theme } from "./Theme";
import AnnouncementIcon from '@mui/icons-material/Announcement';

const AdminApp = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("token");
      // Optional: simulate async check (like API call)
      //await new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds delay

      // You can validate the token here if needed
      // if (token) await fetch("/api/validate", { headers: { Authorization: `Bearer ${token}` } });

      setReady(true);
    };

    checkAuth();
  }, []);

  if (!ready) {
    // Material UI style loading screen
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "background.default",
          color: "text.secondary",
        }}
      >
        <CircularProgress color="primary" size={60} thickness={4} />
        <Typography
          variant="h6"
          sx={{ mt: 2, color: "text.primary", fontWeight: 500 }}
        >
          Loading admin panel...
        </Typography>
      </Box>
    );
  }

  return (
    <Admin
      menu={AdminMenu}
      basename="/admin"
      dataProvider={DataProvider}
      authProvider={AuthProvider}
      layout={AdminLayout}
      requireAuth
      theme={theme}
    >
      <Resource
        name="news"
        list={NewsList}
        edit={NewsEdit}
        create={NewsCreate}
      />

       <Resource
        name="announcements"
        list={AnnouncementsList}
        edit={AnnouncementsEdit}
        create={AnnouncementsCreate}
        icon={AnnouncementIcon}
      />

      <CustomRoutes>
        <Route path="documents" element={<Documents />} />
      </CustomRoutes>
    </Admin>
  );
};

export default AdminApp;
